import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { CompetencyData } from "../Models/competencyModel.model";

@Injectable()
export class SharedcompetencyService {
  private _subject = new Subject();
    

  sendMessage(message: CompetencyData) {
    this._subject.next(message);
  }



  getMessage(): Observable<any> {
    return this._subject.asObservable();
  }
}
